export class MigrationProcessingDataEntity {
  id?: string;
  migrationProcessingId?: string;
  section?: string;
  label?: string;
  inputName?: string; // Immutable key that links to JSON metadata
  inputType?: string;
  templateCode?: string; // User-editable
  targetActivity?: string; // User-editable
  displayOrder?: number;
  isActive?: boolean;
  conditionallyVisibleJson?: string; // JSON string of Condition[]
  conditionallyVisibleLogicalOperator?: string; // AND/OR
  conditionallyRequiredJson?: string; // JSON string of Condition[]
  conditionallyRequiredLogicalOperator?: string; // AND/OR
  parentEntityId?: string; // Parent entity ID for nested fields
  hasChildFields?: boolean; // Indicates if this entity has child fields
  indentLevel?: number; // Indentation level for display (0 = top level)
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;

  // Helper properties (not from backend)
  hasConditionalConfiguration?: boolean;
  expanded?: boolean; // For conditional configuration expansion
  childrenExpanded?: boolean; // For child fields expansion
}
